import { z } from 'zod';
import { insertVenueSchema, venues } from './schema';

export const errorSchemas = {
  validation: z.object({
    message: z.string(),
    field: z.string().optional(),
  }),
  notFound: z.object({
    message: z.string(),
  }),
  internal: z.object({
    message: z.string(),
  }),
};

export const api = {
  venues: {
    list: {
      method: 'GET' as const,
      path: '/api/venues',
      input: z.object({
        lat: z.string().optional(), // Query params come as strings
        lng: z.string().optional(),
        radius: z.string().optional(),
      }).optional(),
      responses: {
        200: z.array(z.custom<typeof venues.$inferSelect>()),
      },
    },
    get: {
      method: 'GET' as const,
      path: '/api/venues/:id',
      responses: {
        200: z.custom<typeof venues.$inferSelect>(),
        404: errorSchemas.notFound,
      },
    },
    create: {
      method: 'POST' as const,
      path: '/api/venues',
      input: insertVenueSchema,
      responses: {
        201: z.custom<typeof venues.$inferSelect>(),
        400: errorSchemas.validation,
      },
    },
    update: {
      method: 'PUT' as const,
      path: '/api/venues/:id',
      input: insertVenueSchema.partial(),
      responses: {
        200: z.custom<typeof venues.$inferSelect>(),
        400: errorSchemas.validation,
        404: errorSchemas.notFound,
      },
    },
  },
};

export function buildUrl(path: string, params?: Record<string, string | number>): string {
  let url = path;
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (url.includes(`:${key}`)) {
        url = url.replace(`:${key}`, String(value));
      }
    });
  }
  return url;
}

export type VenueInput = z.infer<typeof api.venues.create.input>;
export type VenueResponse = z.infer<typeof api.venues.create.responses[201]>;
export type UpdateVenueRequest = z.infer<typeof api.venues.update.input>;
